import {
  Box,
  IconButton,
  IconButtonProps,
  useColorMode,
} from '@chakra-ui/react';
import { HiMoon, HiSun } from 'react-icons/hi';

type ThemeToggleProps = Omit<IconButtonProps, 'aria-label' | 'icon'>;

export function ThemeToggle(props: ThemeToggleProps) {
  const { colorMode, toggleColorMode } = useColorMode();
  const isDark = colorMode === 'dark';

  return (
    <IconButton
      aria-label={isDark ? 'Mudar para tema claro' : 'Mudar para tema escuro'}
      onClick={toggleColorMode}
      size="sm"
      h="40px"
      w="40px"
      minW="40px"
      bg="transparent"
      color="text.muted"
      borderRadius="999px"
      borderWidth="1px"
      borderColor="line.subtle"
      _hover={{
        color: 'accent.500',
        borderColor: 'accent.line',
        bg: 'transparent',
      }}
      _active={{ bg: 'transparent' }}
      icon={
        <Box
          as="span"
          display="inline-flex"
          alignItems="center"
          justifyContent="center"
          transition="transform 0.4s ease"
          transform={isDark ? 'rotate(0deg)' : 'rotate(360deg)'}
          fontSize="16px"
        >
          {isDark ? <HiSun /> : <HiMoon />}
        </Box>
      }
      {...props}
    />
  );
}
